// Считается, что баннеры, старше этой даты - не имеют конца
// Это нужно для удобства хранения и фильтрации данных
export const ENDLESS_DATE = '2999-01-01';
export const MOBILE_COEFF = 750 / 350;
